import { LOCAL__generation_upsert_generation } from '@/state/generation/entity/LOCAL__generation_upsert_generation';
import { store } from '@/state/store';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FN_FIELD_IMAGE_ASSET__init_image } from '../image/_methods/FN_FIELD_IMAGE_ASSET__init_image';

export function HANDLER_CLIENT__generation_graph_fields_upsert(data: any) {
  /*
   * PREPARE DATA
   */
  let items = data;
  assert_array_instanceof(items, FIELD__base);

  let fields_map_by_graph_id = FIELD__base.map_by_graph_id(items);

  /*
   * INIT IMAGES
   */
  let { images_map } = store.getState().slice_images;
  let fields_images = items.filter(field => field instanceof FIELD__image_asset);
  FN_FIELD_IMAGE_ASSET__init_image(images_map, fields_images);

  try_update_field_image_edit(fields_images);
  /*
   * UPDATE GENERATIONS
   */

  let { generations_map } = store.getState().slice_generation;

  let generations_updated = [];

  for (let [generation_id, fields] of fields_map_by_graph_id.entries()) {
    if (!generations_map.has(generation_id)) continue; //not loaded yet

    let generation = generations_map.get_or_assert(generation_id);

    let { graph } = generation.tool;

    let fields_map = graph.fields__get_map();

    //todo: possible bug, mb need replace by field_hash__value_full too
    fields = fields.filter(field => fields_map.has(field.meta.field_id)); //keep only fields that are in graph

    if (fields.is_empty()) continue;

    for (let field of fields) graph.field__replace(field);

    generations_updated.push(generation.clone());
  }

  store.dispatch(LOCAL__generation_upsert_generation(generations_updated));
}

function try_update_field_image_edit(fields_images: FIELD__image_asset[]) {
  let { g_image_edit__field } = store.getState().slice_ui;
  if (g_image_edit__field.is_stub()) return;

  let field_updated = fields_images.find(item => item.meta.field_id == g_image_edit__field.meta.field_id);
  if (!field_updated) return;

  store.dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field: field_updated.clone() }));
}
